<template>
  <b-row>
    <b-col>
      <form @submit.prevent="handleSubmit()">
        <b-row>
          <b-col sm="6">
            <div class="form-group">
              <label
                for="exsbitemscategory_title"
                class="form-control-label">{{$t('views.exsbitemscategories.form.name')}}:</label>
              <input
                id="exsbitemscategory_title"
                v-model="data.title"
                :class="['form-control', isInvalid('title') ? 'is-invalid' : '']"
                type="text"
                required="true"
                placeholder=""
                @input="handleUpdateField('title', $event.target.value)">
              <div
                v-if="isInvalid('title')"
                class="invalid-feedback">{{ violations.title }}</div>
            </div>
          </b-col>
          <b-col sm="6">
            <div class="form-group">
              <label
                for="exsbitemscategory_description"
                class="form-control-label">{{$t('views.exsbitemscategories.form.description')}}:</label>
              <input
                id="exsbitemscategory_description"
                v-model="data.description"
                :class="['form-control', isInvalid('description') ? 'is-invalid' : '']"
                type="text"
                placeholder=""
                @input="handleUpdateField('description', $event.target.value)">
              <div
                v-if="isInvalid('description')"
                class="invalid-feedback">{{ violations.description }}</div>
            </div>
          </b-col>
        </b-row>
        <hr class="mt-2 mb-2">
        <b-row>
          <b-col>
            <b-form-group>
              <label>{{$t("views.agreements.form.dateFrom")}}:</label>
              <VueCtkDateTimePicker no-header
                                    :label="$t('views.agreements.form.dateFrom')"
                                    v-model="data.dateFrom"
                                    format="YYYY-MM-DD"
                                    :noButtonNow="true"
                                    :onlyDate="true"
                                    :right="true"
                                    formatted="ll"
                                    :no-label="true"
              >
              </VueCtkDateTimePicker>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group>
              <label>{{$t("views.agreements.form.dateTo")}}:</label>
              <VueCtkDateTimePicker no-header
                                    :label="$t('views.agreements.form.dateTo')"
                                    v-model="data.dateTo"
                                    format="YYYY-MM-DD"
                                    :noButtonNow="true"
                                    :onlyDate="true"
                                    :right="true"
                                    formatted="ll"
                                    :no-label="true"
              >
              </VueCtkDateTimePicker>
            </b-form-group>
          </b-col>
        </b-row>
        <PackageItems
          :data="data"
          :violations="violations">
        </PackageItems>
        <PackagePromotions
          :data="data"
          :violations="violations">
        </PackagePromotions>
        <PackageDevices
          :data="data"
          :violations="violations"
        ></PackageDevices>
        <hr class="mt-2 mb-2">
        <button type="button" class="btn btn-success" @click="handleSubmit()">{{$t('buttons.submit')}}</button>
      </form>
    </b-col>
  </b-row>
</template>

<script>
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import PackageDevices from '@/components/Dashboard/Views/AgreementsBundle/packages/components/PackageDevices'
import PackageItems from '@/components/Dashboard/Views/AgreementsBundle/packages/components/PackageItems'
import PackagePromotions from '@/components/Dashboard/Views/AgreementsBundle/packages/components/PackagePromotions'

export default {
  name: 'Form',
  components: {
    PackagePromotions,
    PackageItems,
    PackageDevices,
    VueCtkDateTimePicker
  },

  props: {
    values: {
      type: Object,
      required: true
    },
    initialValues: {
      type: Object,
      default: () => {}
    },
    handleSubmit: {
      type: Function,
      required: true
    },
    violations: {
      type: Object,
      required: true
    },
    handleUpdateField: {
      type: Function,
      required: true
    }
  },

  data () {
    return {
      item: {}
    }
  },
  computed: {
    data () {
      return this.values || this.initialValues
    }
  },
  methods: {
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    }
  }
}
</script>
